/** Tâches et objectifs : la liste, la création et la page d'une tâche. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';
// Éager : la barre basse du terrain y mène en un geste.
import { TasksPage } from './TasksPage.js';

const TaskNewPage = lazy(() => import('./TaskNewPage.js').then((m) => ({ default: m.TaskNewPage })));
const TaskEditPage = lazy(() => import('./TaskEditPage.js').then((m) => ({ default: m.TaskEditPage })));

// Sans droit : chacun a ses propres tâches ; l'API vérifie qui peut donner, lire et modifier.
export const tasksRoutes: AppRoute[] = [
  { path: '/taches', element: <TasksPage /> },
  { path: '/taches/nouvelle', element: <TaskNewPage /> },
  { path: '/taches/:id/modifier', element: <TaskEditPage /> },
];
